import { useDispatch, useSelector } from 'react-redux';

import { modalActions } from '@/redux/reducer/modal-reducer';

export const useModal = (modalId: string) => {
  const dispatch = useDispatch();
  const modal = useSelector((state: any) => state.modal.modals[modalId]);

  const openModal = () => {
    dispatch(modalActions.openModal({ modalId }));
  };

  const closeModal = () => {
    dispatch(modalActions.closeModal({ modalId }));
  };

  return {
    openModal,
    closeModal,
    open: modal?.open,
  };
};
